// "Where to watch" chips shown next to each fixture: the Sport TV channel
// (paid) plus any free-to-air outlet (RTP1/SIC/TVI) and LiveModeTV (free, on
// YouTube) where confirmed. Channel data lives in fixtures.ts; display rules
// in broadcast.ts.

import { CHANNEL_META, channelsFor } from "./broadcast";
import type { Match } from "./fixtures";
import type { MundialStrings } from "./strings";

export function BroadcastChips({
  match,
  str,
}: {
  match: Match;
  str: MundialStrings;
}) {
  const b = str.broadcast;
  return (
    <span className="flex flex-wrap items-center gap-1">
      {channelsFor(match).map((code) => {
        const meta = CHANNEL_META[code];
        const free = meta.kind === "free";
        const title = free ? b.free : b.paid;
        const className = free
          ? "rounded bg-[var(--mundial-gold)]/20 px-1.5 py-0.5 text-[0.65rem] font-semibold text-[var(--mundial-gold-deep)]"
          : "rounded bg-muted px-1.5 py-0.5 text-[0.65rem] font-medium text-muted-foreground";
        return meta.href ? (
          <a
            key={code}
            href={meta.href}
            target="_blank"
            rel="noopener noreferrer"
            title={title}
            className={`${className} hover:underline`}
          >
            {meta.label}
          </a>
        ) : (
          <span key={code} title={title} className={className}>
            {meta.label}
          </span>
        );
      })}
    </span>
  );
}
